import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { GraphData } from '@classes/graph/graph';
import { RecordsCoudPouce } from '@classes/records/record';
import { DataService } from '@services/data/data.service';
import { RecordsService } from '@services/records/records.service';
import { SubscriptionBaseComponent } from 'app/shared/subscription-base/subscription-base';
import { ChartType } from 'chart.js';
import { Label, MultiDataSet } from 'ng2-charts';

@Component({
  selector: 'app-chart-clicote',
  templateUrl: './chart-clicote.component.html',
  styleUrls: ['./chart-clicote.component.scss']
})
export class ChartClicoteComponent extends SubscriptionBaseComponent implements OnInit {

  @Input() numberDayOfMonth: number;
  @Input() year: number;
  @Input() month: string;

  arrayMonth = ['Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'];

  public barChartOptions = {
    responsive: true,
    legend: {
      display: true

    },
    layout: {
      padding: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 50
      }
    }
  };

  doughnutChartLabels: Label[] = ['Tri', 'Cintrage', 'O\'kilos', 'Vente'];
  doughnutChartData = [0, 0, 0, 0];

  doughnutChartType: ChartType = 'doughnut';


  // public barChartLabels = ['Tri', 'Cintrage', 'O\'kilo', 'Vente'];
  // public barChartType = 'bar';
  // public barChartLegend = true;
  // public barChartPlugins = [];

  // // data: RecordsCoudPouce[] = [];
  // dataLabel: GraphData = {
  //   label: 'Clicote Origine',
  //   data: [0, 0, 0, 0]
  // };
  // public barChartData = this.dataLabel;
  typeTime: string;
  data: RecordsCoudPouce[];
  showDoughnutChart = false;

  constructor(
    private recordsService: RecordsService,
    private dataService: DataService,
    private cdr: ChangeDetectorRef
  ) {
    super();
  }

  ngOnInit(): void {
    this.initSub();

  }

  getMonthOrYear(): string {
    let string = '';

    this.typeTime === 'month' ?
      string = `${this.arrayMonth[this.month]} ${this.year}` :
      string = `${this.year}`;

    return string;
  }

  private initValueGraph(): void {
    this.doughnutChartData = [0, 0, 0, 0];
    let result = 0;



    this.data?.forEach(item => {
      switch (item.step.description) {
        case 'Tri':
          item.type === 'Output' && item.category.name === 'Clicotte' ?
            this.doughnutChartData[0] += item.value :
            null;
          break;

        case 'Cintrage':
          item.type === 'Output' && item.category.name === 'Clicotte' ?
            this.doughnutChartData[1] += item.value :
            null;
          break;

        case 'O\'kilos':
          item.type === 'Output' && item.category.name === 'Clicotte' ?
            this.doughnutChartData[2] += item.value :
            null;
          break;

        case 'Fripeschic':
          item.type === 'Output' && item.category.name === 'Clicotte' ?
            this.doughnutChartData[3] += item.value :
            null;
          break;

        default:
          break;
      }

      this.doughnutChartData.forEach(it => {
        result += it;
      });

      this.showDoughnutChart = result === 0 ? false : true;

    });



  }

  private initSub(): void {

    this.subscription
      .add(
        this.recordsService.eventsListSubject.asObservable().subscribe(event => {
          this.dataService.dataGraph$.next(event?.body);
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.typeTime$.asObservable().subscribe(typeTime => {
          this.typeTime = typeTime;
          this.cdr.detectChanges();
        })
      )
      .add(
        this.dataService.dataGraph$.asObservable().subscribe(dataGraph => {
          this.data = dataGraph;
          this.cdr.detectChanges();
          // this.initGraph();
          this.initValueGraph();
        })
      );


  }
}
